import {useHistory} from '@aboutyou/router';

export const useHistoryPush = () => {
  const {push} = useHistory();

  return push;
};
